import {
  CollaborativeDocumentRefDocument,
  CollaborativeDocumentRefFragment,
  CollaborativeDocumentRefFragmentDoc,
  CollaborativeDocumentRefQuery,
  CollaborativeDocumentRefQueryVariables,
  withStandardRefHook,
} from '@spotify/confidence-graphql';

export const useCollaborativeDocumentRef = withStandardRefHook<
  CollaborativeDocumentRefQuery,
  CollaborativeDocumentRefFragment,
  'collaborativeDocument',
  CollaborativeDocumentRefQueryVariables
>(
  CollaborativeDocumentRefDocument,
  'collaborativeDocument',
  CollaborativeDocumentRefFragmentDoc,
  'CollaborativeDocumentRef',
  'CollaborationV1CollaborativeDocument',
);
